module.exports = __webpack_public_path__ + "static/media/7.734cb4f6.svg";